/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

function openDatasetPane(dashboardApi) {
	if (dashboardApi) {
		// TODO: cleanup, provide API to check if datasetpane is open/closed without reaching into glass
		const plugin = dashboardApi.findGlassPlugin('com.ibm.bi.dashboard.dataSources.sourcesBtn');
		if (plugin && !plugin.isPressed()) {
			dashboardApi.getCurrentContentView().openDatasetpane();
		}
	}
}

function openCardsPane(dashboardApi) {
	if (dashboardApi) {
		// TODO: cleanup, provide API to check if card list is open/closed without reaching into glass
		const plugin = dashboardApi.findGlassPlugin('com.ibm.bi.explore.thumbnailBtn');
		if (plugin && !plugin.isPressed()) {
			dashboardApi.getCurrentContentView().openCardListPane();
		}
	}
}

export {
	openDatasetPane,
	openCardsPane
};



// WEBPACK FOOTER //
// ./src/js/util/SidePanelUtil.js